jQuery(function ($) {
	var $container = $('.js-slider-brands');
	if ($container.length) {
		$container.slick({
			infinite: true,
			arrows: false,
			slidesToShow: 1,
			variableWidth: true,
			autoplay: true,
			centerMode: false,
			swipe: true,
			pauseOnHover: false,
			draggable: true,
			responsive: [
				{
					breakpoint: 1201,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 901,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 681,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 521,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
						vertical: true,
					},
				},
			],
		});
	}
});
